var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvaArrowIosBackOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47527 4.16676C8.59977 4.16634 8.72277 4.19381 8.83526 4.24717C8.94774 4.30053 9.04684 4.37841 9.12527 4.4751L13.1503 9.47509C13.2728 9.62421 13.3398 9.81124 13.3398 10.0043C13.3398 10.1973 13.2728 10.3843 13.1503 10.5334L8.9836 15.5334C8.84216 15.7036 8.6389 15.8106 8.41854 15.8309C8.19819 15.8513 7.97879 15.7832 7.80861 15.6418C7.63842 15.5003 7.5314 15.2971 7.51109 15.0767C7.49077 14.8563 7.55882 14.6369 7.70027 14.4668L11.4253 10.0001L7.82527 5.53343C7.72337 5.41111 7.65864 5.26216 7.63874 5.1042C7.61884 4.94624 7.6446 4.78589 7.71298 4.64212C7.78136 4.49834 7.8895 4.37717 8.02459 4.29292C8.15968 4.20868 8.31608 4.1649 8.47527 4.16676Z",
    fill: "#BDBDBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaArrowIosBackOutline);
export default __webpack_public_path__ + "static/media/eva_arrow-ios-back-outline.e5057894858132efcbf26cdbdb53669c.svg";
export { ForwardRef as ReactComponent };